<template>
    <div class="survey">
        <div class="title">
            <div class="bigtitle">{{surveyDetail.surveyName}}</div>
            <div class="subtitle">{{surveyDetail.surveyNote}}</div>
        </div>
        <div class="question">
            <ul>
                <li v-for="(item,index) in surveyQuesCurrent" :key="index">
                    <div v-if="item.quType=='RADIO'">
                        <h4 disabled>{{item.quIndex+1}}.{{item.quTitle}}</h4>
                        <van-radio-group v-model="surveyAnswers[item.quIndex].answer">
                            <van-cell-group>
                                <van-cell v-for="(li,idx) in item.quRadios" clickable :key="idx">
                                    <van-radio :name="li.id">{{li.optionName}}</van-radio>
                                </van-cell>
                            </van-cell-group>
                        </van-radio-group>
                    </div>
                    <div v-else-if="item.quType=='CHECKBOX'">
                        <h4 disabled>{{item.quIndex+1}}.{{item.quTitle}}</h4>
                        <van-checkbox-group v-model="surveyAnswers[item.quIndex].answer">
                            <van-cell-group>
                                <van-cell v-for="(li,idx) in item.quCheckboxs" clickable :key="idx">
                                    <van-checkbox :name="li.id" ref="checkboxes"> {{li.optionName}}</van-checkbox>
                                </van-cell>
                            </van-cell-group>
                        </van-checkbox-group>
                    </div>
                    <div v-else>
                        <h4 disabled>{{index+1}}.{{item.quTitle}}</h4>
                        <van-cell-group>
                            <van-field type="textarea" v-model="surveyAnswers[item.quIndex].answer" placeholder="请输入留言" rows="1" autosize />
                        </van-cell-group>
                    </div>
                </li>
            </ul>
        </div>
        <div class="icons">
            <button type="button" v-show="surveyPageIndex>0" @click="pagePrevious">上一页</button>
            <button type="button" @click="next">下一页</button>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions,
        mapMutations
    } from "vuex";
    import {
        Checkbox,
        CheckboxGroup
    } from 'vant';
    import api from '@/fetch/surveyApi';
    export default {
        data() {
            return {
                customerID: ''
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getCustomerID(vm)
            })
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo", "surveyDetail", "surveyPageIndex", "surveyQuesCurrent", "surveyPageCount", "surveyAnswers"])
        },
        created() {
            this.getSurvey();
            this.setPageIndex(0);
        },
        methods: {
            ...mapActions({
                getSurvey: "getSurvey"
            }),
            ...mapMutations({
                pageNext: "SET_SURVEY_PAGE_NEXT",
                pagePrevious: "SET_SURVEY_PAGE_PREVIOUS",
                setPageIndex: "SET_SURVEY_PAGE_INDEX"
            }),
            getCustomerID(el) {
                this.customerID = el.$route.params.customerID;
                console.log(this.customerID);
            },
            next() {
                if (this.surveyPageIndex < this.surveyPageCount - 1){
                    //  console.log(this.surveyAnswers);
                    window.scroll(0, 0);
                    this.pageNext();
                }
                    
                else {
                    let answers = {
                        compCheckboxMaps: {}, //复选
                        chenFbkMaps: {},
                        compChenRadioMaps: {},
                        scoreMaps: {},
                        compRadioMaps: {}, //单选
                        yesnoMaps: {},
                        multifillblankMaps: {},
                        chenScoreMaps: {},
                        chenCheckboxMaps: {},
                        enumMaps: {},
                        answerMaps: {},
                        quOrderMaps: {},
                        fillblankMaps: {}, //填空题
                        chenRadioMaps: {}
                    };
                    console.log(this.surveyAnswers);
                    this.surveyAnswers.forEach(el => {
                        if (el.quType == 'RADIO') {
                            answers.compRadioMaps[el.quId] = {
                                quId: el.quId,
                                quItemId: el.answer,
                                otherText: '',
                                visibility: 1
                            };
                        } else if (el.quType == 'CHECKBOX') {
                            let ansCBX = {};
                            el.answer.forEach(ele => {
                                ansCBX[ele] = {
                                    quItemId: ele,
                                    otherText: '',
                                    visibility: 1
                                };
                            });
                            answers.compCheckboxMaps[el.quId] = ansCBX;
                        } else if (el.quType == 'FILLBLANK') {
                            answers.fillblankMaps[el.quId] = el.answer;
                        }
                    });
                    console.log(answers);
                    //   console.log(JSON.stringify(answers));
                    api.getAnswer(this.customerID, answers).then(re => {
                        console.log(re)
                        if (re.result == true) {
                            this.$router.replace({
                                path: '/user/GXHTC/'+this.customerID
                            });
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .survey {
        font-family: "Microsoft YaHei" !important;
        .title {
            background-color: #aacd06;
            color: #fff;
            .bigtitle {
                text-align: center;
                font-size: 1.2rem;
                line-height: 2.4rem;
            }
            .subtitle {
                text-align: center;
                font-size: 0.8rem;
                line-height: 2rem;
            }
        }
        .question {
            ul {
                background-color: #f0f0f0;
            }
            li {
                background-color: #fff;
                margin: 0.5rem 0;
                h4 {
                    // margin-left: 1rem;
                    margin: 0 0 0 1rem;
                    line-height: 3rem;
                }
            }
        }
        .icons {
            // position: fixed;
            // bottom: 0;
            text-align: center;
            width: 100%; // margin-top: 2rem;
            padding: 2em 0;
            i {
                color: #619534;
                font-size: 1.2rem;
            }
            button {
                margin: 0 1rem;
                background: inherit;
                background-color: #aacd06;
                box-sizing: border-box;
                border-width: 1px;
                border-style: solid;
                border-radius: 6px;
                box-shadow: none;
                text-align: center;
                font-size: 0.8em;
                height: 2.5rem;
                width: 30%;
                color: #fff;
                border-color: #aacd06; // position: absolute;
            }
            .past {
                color: #aacd06;
                border-color: #aacd06;
                background-color: #fff;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/survey.vue